export default "__VITE_ASSET__881339d7__"